import { ReservationStage } from '../../../utils/owner-portal/reservationConstants';
import { ReservationGeneral } from '../../../models/owner-portal/reservationGeneral';
import { CalendarReservationContentMode } from '../../../models/owner-portal/calendarEvents';
import { headerType } from '../../../components/table/useDynamicTableHeaders';

// ----------------------------------------------------------------------
const TABLE_HEAD: headerType[] = [
  { id: 'name', label: 'Name', align: 'left' },
  { id: 'ui_table_guest_name', label: 'Guest Name', align: 'left' },
  { id: 'guest_type', label: 'Guest Type', align: 'left' },
  { id: 'check_in_ISO', label: 'Dates', align: 'left' },
  { id: 'rental_amount', label: 'Rate', align: 'left' },
  { id: 'booking_date_ISO', label: 'Booked On', align: 'left' },
  { id: '', align: 'right' }
];
const EXTRA_ALL_HEADERS: headerType[] = [{ id: 'unit_id', label: 'Property', align: 'left' }];
const TABLE_HEAD_ALL = [TABLE_HEAD[0], ...EXTRA_ALL_HEADERS, ...TABLE_HEAD.slice(1)];
export const createReservationTableHead = (mode: CalendarReservationContentMode) => {
  if (mode === CalendarReservationContentMode.All) {
    return TABLE_HEAD_ALL;
  }
  return TABLE_HEAD;
};
export const defaultStageFilter: string = ReservationStage.Confirmed;

export const mobileBreakpointKeys: (keyof ReservationGeneral | '')[] = [
  'name',
  'check_in_ISO',
  'rental_amount',
  ''
];
export const tabletBreakpointKeys: (keyof ReservationGeneral | '')[] = [
  'name',
  'unit_id',
  'ui_table_guest_name',
  'check_in_ISO',
  'rental_amount',
  ''
];
export const desktopBreakpointKeys: (keyof ReservationGeneral | '')[] = [
  'name',
  'unit_id',
  'ui_table_guest_name',
  'display_guest_type',
  'check_in_ISO',
  'rental_amount',
  ''
];
